import axios from "axios";
import {environmentConfig} from "@/config/enviromentConfig";
import {ServiceIdsMtn} from "@/config/index";

const headers = {Authorization: `Basic Vm9kYXBheTpIWUtqSHlUODBnQQ==`};

export default class RewardCampaignService {
    static async getUserVouchers(msisdn,productId) {
        const response = await axios.post(`${environmentConfig.campaignHubService}/get-user-vouchers/v2`, {
                msisdn,
                productId,
            }, {headers}
        )
        return response.data;
    }
}
